import { useMemo } from 'react'
import { useApiConfig } from '../../../hooks/useApiConfig'

// allowCurrent=false skryje aktuální rok — pro produkty, které dávají smysl až nad
// kompletním rokem (např. větrná růžice), takže nejvyšší volitelný rok je loňský.
export function YearPeriodPicker({ year, onYearChange, obsType, headerExtra, allowCurrent = true }) {
  const config = useApiConfig()
  const currentYear = new Date().getFullYear()
  const maxYear = allowCurrent ? currentYear : currentYear - 1

  const minYear = useMemo(() => {
    const raw = config.backfillMinDate?.[obsType]
    if (!raw) return 1900
    return new Date(raw).getUTCFullYear()
  }, [config, obsType])

  const yearWindow = useMemo(() => {
    const start = year <= maxYear && year >= maxYear - 4
      ? maxYear - 4
      : year - 2
    return Array.from({ length: 5 }, (_, i) => start + i)
      .filter(y => y >= minYear && y <= maxYear)
  }, [year, maxYear, minYear])

  const canGoBack    = yearWindow[0] > minYear
  const canGoForward = yearWindow[yearWindow.length - 1] < maxYear

  function shiftWindow(delta) {
    const newStart = yearWindow[0] + delta * 5
    const clamped = Math.max(minYear, Math.min(maxYear, newStart))
    onYearChange(clamped)
  }

  return (
    <div className="flex items-start gap-4">
      <div className="flex items-center gap-1">
        <button
          className="px-1.5 py-0.5 text-lg leading-none text-gray-400 hover:text-gray-700 disabled:opacity-30"
          onClick={() => shiftWindow(-1)}
          disabled={!canGoBack}
        >‹</button>
        {yearWindow.map(y => (
          <button
            key={y}
            onClick={() => onYearChange(y)}
            className={`px-3 py-0.5 rounded text-sm font-medium transition-colors ${
              y === year ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {y}
          </button>
        ))}
        <button
          className="px-1.5 py-0.5 text-lg leading-none text-gray-400 hover:text-gray-700 disabled:opacity-30"
          onClick={() => shiftWindow(1)}
          disabled={!canGoForward}
        >›</button>
      </div>

      {headerExtra && <div className="ml-auto flex flex-wrap items-start gap-8">{headerExtra}</div>}
    </div>
  )
}
